import PolicyPage from "@/pages/PolicyPage";

const H = ({ children }) => (
  <h2 className="text-2xl font-semibold tracking-tight mt-12 mb-4 text-graphite">{children}</h2>
);

export default function Terms() {
  return (
    <PolicyPage
      title="Terms and Conditions"
      meta="The terms on which Carlton Elleker Chase provides its website and services."
    >
      <p className="font-semibold tracking-tight">PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING THIS SITE</p>

      <H>Who we are and how to contact us</H>
      <p>
        https://ceclegal.co.uk/ and any other site with this first level domain name (the “Site”)
        are websites operated by Carlton Elleker Chase Limited (“we” and “us”). We are registered
        in England and Wales under company number 12957929 and have our registered office at 1
        Quality Court, Chancery Lane, London, WC2A 1HR which is also our main trading address.
      </p>
      <p>We are a law firm authorised by the Solicitors Regulation Authority, SRA No: 8006648.</p>
      <p>To contact us, please email info@ceclegal.co.uk or call us on +44 (0) 203 105 1755.</p>

      <H>By using our Site you accept these terms</H>
      <p>
        By using our Site or application, or any service made available by us through the Site
        (together referred to as the “Service”), you confirm that you accept these terms of use
        and that you agree to comply with them.
      </p>
      <p>If you do not agree to these terms, you must not use our Site.</p>
      <p>We recommend that you print a copy of these terms for future reference.</p>

      <H>Provided Service</H>
      <p>
        Our Service allows users to view information relating to the provision of legal services,
        including marketing material, know-how content and information about our legal services.
      </p>
      <p>
        The Service contains material owned by us and is protected by Intellectual Property
        Rights. Intellectual Property Rights means rights such as copyright, trade marks, domain
        names, design rights, database rights, patents and all other intellectual or industrial
        property rights of any kind whether registered (anywhere in the world) or not. Subject to
        these Terms, we give you a personal, non-exclusive, non-transferable, and revocable
        licence to use our Service.
      </p>
      <p>
        The Service is completely free of charge, but any additional services, like contacting a
        lawyer are provided separately and may require payment of fees.
      </p>

      <H>There are other terms that may apply to you</H>
      <p>
        These terms of use refer to our <a href="/privacy" className="text-[#1E3668] hover:underline">Privacy Policy</a> which you must also read before using the Site.
      </p>

      <H>We may make changes to these terms</H>
      <p>
        We amend these terms from time to time. Every time you wish to use our Site or Services,
        please check these terms to ensure you understand the terms that apply at that time. These
        terms were most recently updated on 15 December 2025.
      </p>

      <H>We may make changes to our Site and Services</H>
      <p>
        We may update and change our Site from time to time to improve functionality, user
        experience and general upgrading, as well as to meet our business needs.
      </p>

      <H>We may suspend or withdraw our Site and Services</H>
      <p>
        We do not guarantee that our Site or Services, or any content on it, will always be
        available or be uninterrupted. We may suspend, withdraw or restrict the availability of
        all or any part of our Site or Services for business and operational reasons. We will try
        to give you reasonable notice of any suspension or withdrawal where appropriate.
      </p>
      <p>
        You are also responsible for ensuring that all persons who access our Site or use our
        Services through your internet connection are aware of these terms of use and other
        applicable terms and conditions, and that they comply with them.
      </p>

      <H>You must keep your account details safe</H>
      <p>
        If you choose, or you are provided with, a user identification code, password or any other
        piece of information as part of our security procedures, you must treat such information
        as confidential. You must not disclose it to any third party.
      </p>
      <p>
        We have the right to disable any user identification code or password, whether chosen by
        you or allocated by us, at any time, if in our reasonable opinion you have failed to
        comply with any of the provisions of these terms of use.
      </p>
      <p>
        If you know or suspect that anyone other than you knows your user identification code or
        password, you must promptly notify us at info@ceclegal.co.uk.
      </p>

      <H>How you may use material on our Site</H>
      <p>
        We are the owner or the licensee of all Intellectual Property Rights in our Site, and in
        the material published on it. Those works are protected by copyright laws and treaties
        around the world. All such rights are reserved.
      </p>
      <p>
        Nothing in these terms grants you any legal rights in the Site other than as necessary to
        enable you to access the Site. You agree not to try to circumvent or delete any notices
        contained on the Site (including any Intellectual Property notices) and in particular in
        any digital rights or other security technology embedded or contained within the Site.
      </p>
      <p>
        You must not use any part of the content on our Site for commercial purposes without
        obtaining a licence to do so from us or our licensors.
      </p>

      <H>Making copies</H>
      <p>
        You may print off one copy, and may download extracts, of any page(s) from our Site for
        your personal use and you may draw the attention of others within your organisation to
        content posted on our Site.
      </p>
      <p>
        You must not modify the paper or digital copies of any materials you have printed off or
        downloaded in any way, and you must not use any illustrations, photographs, video or audio
        sequences or any graphics separately from any accompanying text.
      </p>
      <p>
        Our status (and that of any identified contributors) as the authors of content on our Site
        must always be acknowledged.
      </p>
      <p>
        If you print off, copy or download any part of our Site in breach of these terms of use,
        your right to use our Site will cease immediately and you must, at our option, return or
        destroy any copies of the materials you have made.
      </p>

      <H>Do not rely on information on this Site or Service</H>
      <p>The content on our Site including:</p>
      <ul className="list-disc pl-6 space-y-2">
        <li>legal information or know-how contained within, in any format;</li>
        <li>information on our clients, work we have completed or employment histories; and</li>
        <li>any other kind of analyses, reports and results generated from use of our Service,</li>
      </ul>
      <p>
        are provided for general information only and are not intended to constitute legal
        opinions or advice of any kind on which you should rely.
      </p>
      <p>
        Any exploitation of or use of results from the Service are done so at your sole
        responsibility.
      </p>
      <p>
        You must obtain professional or specialist advice before taking, or refraining from, any
        action on the basis of the content on our Site or Service.
      </p>
      <p>
        Although we make reasonable efforts to update the information on our Site, we make no
        representations, warranties or guarantees, whatsoever, whether express or implied, that
        the content on our Site or through our Service is accurate, complete or up to date.
      </p>

      <H>We provide no warranty as to the Site or Service</H>
      <p>
        To the maximum extent possible under law, we provide no warranty of any kind, whether
        express or implied, as to the performance, accuracy, availability, security, reliability
        or fitness for a particular purpose of the Site or Services.
      </p>
      <p>
        We also accept no liability for the deletion of, or the failure to store or transmit any
        material or content and any other communications maintained in the Site or Service.
      </p>

      <H>We are not responsible for websites we link to</H>
      <p>
        The Site and Service may contain links to third party websites, advertisers, services,
        special offers, or other events or activities that are not owned or controlled by us.
      </p>
      <p>There may also be links to third party websites or features within the Service.</p>
      <p>The Service may include third party content that we do not control, maintain or endorse.</p>
      <p>
        We will not and cannot assume any responsibility for the content, privacy policies or
        practices of any third party content or websites or any of their content.
      </p>
      <p>
        Any such third party links should not be interpreted as approval by us of those linked
        websites or information you may obtain from them.
      </p>

      <H>User-generated content is not approved by us</H>
      <p>
        This website may include information and materials uploaded by other users of the Site.
        This information and these materials have not been verified or approved by us. The views
        expressed by other users on our Site do not represent our views or values.
      </p>
      <p>
        If you wish to complain about information and materials uploaded by other users please
        contact us on info@ceclegal.co.uk.
      </p>

      <H>Our responsibility for loss or damage suffered by you</H>
      <p>
        If you are either a consumer or a business user we do not exclude or limit in any way our
        liability to you where it would be unlawful to do so. This includes liability for death or
        personal injury caused by our negligence or the negligence of our employees, agents or
        subcontractors and for fraud or fraudulent misrepresentation.
      </p>
      <p><strong>If you are a business user:</strong></p>
      <ul className="list-disc pl-6 space-y-2">
        <li>We exclude all implied conditions, warranties, representations or other terms that may apply to our Site, Service or any content on it.</li>
        <li>We will not be liable to you for any loss or damage, whether in contract, tort (including negligence), breach of statutory duty, or otherwise, even if foreseeable, arising under or in connection with: use of, or inability to use, our Site or Service; or use of or reliance on any content displayed on our Site.</li>
        <li>In particular, we will not be liable for: loss of profits, sales, business, or revenue; business interruption; loss of anticipated savings; loss of business opportunity, goodwill or reputation; or any indirect or consequential loss or damage.</li>
      </ul>
      <p><strong>If you are a consumer user:</strong></p>
      <ul className="list-disc pl-6 space-y-2">
        <li>Please note that we only provide our Site and Service for domestic and private use. You agree not to use our Site or our Service for any commercial or business purposes, and we have no liability to you for any loss of profit, loss of business, business interruption, or loss of business opportunity.</li>
      </ul>

      <H>How we may use your personal information</H>
      <p>We will only use your personal information as set out in our <a href="/privacy" className="text-[#1E3668] hover:underline">Privacy Policy</a>.</p>

      <H>We are not responsible for viruses and you must not introduce them</H>
      <p>We do not guarantee that our Site will be secure or free from bugs or viruses.</p>
      <p>
        You are responsible for configuring your information technology, computer programmes and
        platform to access our Site. You should use your own virus protection software.
      </p>
      <p>
        You must not misuse our Site by knowingly introducing viruses, trojans, worms, logic bombs
        or other material that is malicious or technologically harmful. You must not attempt to
        gain unauthorised access to our Site, the server on which our Site is stored or any
        server, computer or database connected to our Site. You must not attack our Site via a
        denial-of-service attack or a distributed denial-of-service attack.
      </p>
      <p>By breaching this provision, you would commit a criminal offence under the Computer Misuse Act 1990.</p>
      <p>
        We will report any such breach to the relevant law enforcement authorities and we will
        co-operate with those authorities by disclosing your identity to them. In the event of
        such a breach, your right to use our Site will cease immediately.
      </p>

      <H>Rules about linking to our Site</H>
      <p>
        You may link to our home page, provided you have obtained our written consent and do so in
        a way that is fair and legal and does not damage our reputation or take advantage of it.
      </p>
      <p>
        You must not establish a link in such a way as to suggest any form of association,
        approval or endorsement on our part where none exists.
      </p>
      <p>You must not establish a link to our Site in any website that is not owned by you.</p>
      <p>
        Our Site must not be framed on any other Site, nor may you create a link to any part of
        our Site other than the home page.
      </p>
      <p>We reserve the right to withdraw linking permission without notice.</p>

      <H>Which country’s laws apply to any disputes?</H>
      <p>
        If you are a consumer, please note that these terms of use, their subject matter and their
        formation, are governed by English law. You and we both agree that the courts of England
        and Wales will have exclusive jurisdiction except that if you are a resident of Northern
        Ireland you may also bring proceedings in Northern Ireland, and if you are resident of
        Scotland, you may also bring proceedings in Scotland.
      </p>
      <p>
        If you are a business, these terms of use, their subject matter and their formation (and
        any non-contractual disputes or claims) are governed by English law. We both agree to the
        exclusive jurisdiction of the courts of England and Wales.
      </p>
    </PolicyPage>
  );
}
